import { useEffect, useState } from "react";
import api from "../api";
//
export default function SessionTimeout({ logoutUser }) {

    const timeout =
        Number(sessionStorage.getItem("sessionTimeoutMinutes")) || 120;

    const warningMinutes = 5;

    const [show, setShow] = useState(false);
    const [remaining, setRemaining] = useState(0);

    useEffect(() => {
        console.log("SessionTimeout Started");
        const timer = setInterval(() => {

            const loginTime =
                Number(sessionStorage.getItem("loginTime"));

            const expireTime =
                loginTime + timeout * 60 * 1000;

            const diff = expireTime - Date.now();
              // console.log({
              //       timeout,
              //       loginTime,
              //       expireTime,
              //       diff
              //   });
            if (diff <= 0) {

                clearInterval(timer);

                sessionStorage.clear();

                logoutUser();

                return;
            }

            const warning =
                warningMinutes * 60 * 1000;

            if (diff <= warning) {

                setShow(true);

                setRemaining(
                    Math.floor(diff / 1000)
                );
            }

        },1000);

        return ()=>clearInterval(timer);

    },[]);

    // const stayLoggedIn = async ()=>{

    //     try{

    //         await api.get("/check-session");

    //         localStorage.setItem("loginTime",Date.now());

    //         setShow(false);

    //     }
    //     catch{

    //         logoutUser();

    //     }

    // };

    // SessionTimeout.jsx
const stayLoggedIn = async () => {
    try {
        const res = await api.post("/refresh-session"); // ← was /check-session (GET)

        sessionStorage.setItem("loginTime", Date.now());
        sessionStorage.setItem("sessionTimeoutMinutes", res.data.sessionTimeoutMinutes);

        setShow(false);
    } catch {
        logoutUser();
    }
};
    
    const logout = async()=>{

        await api.post("/logout");

        sessionStorage.clear();

        logoutUser();

    };

    const mm =
        String(Math.floor(remaining/60)).padStart(2,"0");

    const ss =
        String(remaining%60).padStart(2,"0");

    if(!show) return null;

    if (!show) return null;

return (
  <div
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.45)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 99999
    }}
  >
    <div
      style={{
        width: "420px",
        background: "#fff",
        padding: "30px",
        borderRadius: "10px",
        boxShadow: "0 10px 30px rgba(0,0,0,.3)",
        textAlign: "center"
      }}
    >
      <h2
        style={{
          marginBottom: "15px"
        }}
      >
        ⏳ Session Expiring Soon
      </h2>

      <p>
        Your session will expire in <b>5 minutes</b> due to inactivity.
      </p>

      <p>Stay logged in to continue working.</p>

      <h3
        style={{
          fontSize: "32px",
          margin: "20px 0",
          color: "#e74c3c"
        }}
      >
        {mm}:{ss}
      </h3>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "15px"
        }}
      >
        <button
          onClick={stayLoggedIn}
          style={{
            padding: "10px 20px",
            cursor: "pointer",
            background: "#28a745",
            color: "#fff",
            border: "none",
            borderRadius: "5px"
          }}
        >
          Stay Logged In
        </button>

        <button
          onClick={logout}
          style={{
            padding: "10px 20px",
            cursor: "pointer",
            background: "#dc3545",
            color: "#fff",
            border: "none",
            borderRadius: "5px"
          }}
        >
          Log Out
        </button>
      </div>
    </div>
  </div>
);

}